import dhtmlXTabBar from './dxSource/components/dhtmlXTabBar';
import InitGridObj from './dxInitUtils/initGridObj.js';

let DxUtils={
    //初始化表格
    initGridObjCtl(gridId, config, vueObj){
        return InitGridObj(gridId, config, vueObj);
    },
    //初始化tabset组件
    initDhtmlXTabBar(elObj){
        return new dhtmlXTabBar(elObj);
    }
};
export default DxUtils;



// WEBPACK FOOTER //
// ./goingsrc/dx/index.js